import { Directive, ElementRef, forwardRef, HostListener, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[appFormatoPeso]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormatoPesoDirective),
      multi: true
    }
  ]
})
export class FormatoPesoDirective implements ControlValueAccessor {

  @Input() enterosPermitidos: number = 1;

  private onChange: (value: number | null) => void = () => { };
  private onTouched: () => void = () => { };

  constructor(private el: ElementRef<HTMLInputElement>) { }

  writeValue(value: any): void {
    if (value !== null && value !== undefined) {
      const stringValue = value.toString().replace('.', ',');
      this.formatAndSetValues(stringValue, false);
    } else {
      this.el.nativeElement.value = '';
    }
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean): void { this.el.nativeElement.disabled = isDisabled; }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    this.formatAndSetValues(value, true);
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }


  // --- Lógica principal de formateo durante el tipeo ---
  private formatAndSetValues(value: string, emitChangeToModel: boolean) {
    let valorLimpio = value.replace(/[^0-9,]/g, '');

    const partes = valorLimpio.split(',');
    if (partes.length > 2) {
      valorLimpio = partes[0] + ',' + partes[1];
    }

    let [enteros, decimales] = valorLimpio.split(',');

    if (enteros && enteros.length > this.enterosPermitidos) {
      if (decimales === undefined) {
        decimales = enteros.substring(this.enterosPermitidos);
        enteros = enteros.substring(0, this.enterosPermitidos);
      } else {
        enteros = enteros.substring(0, this.enterosPermitidos);
      }
    }

    if (decimales && decimales.length > 3) {
      decimales = decimales.substring(0, 3);
    }

    let viewValue = enteros || '';
    if (decimales !== undefined) {
      viewValue += ',' + decimales;
    }

    this.el.nativeElement.value = viewValue;

    if (emitChangeToModel) {
      let modelValue: number | null = null;
      if (viewValue) {
        modelValue = parseFloat(viewValue.replace(',', '.'));
      }
      this.onChange(modelValue);
    }
  }
}